import Quote from '@nxt-insurance/ui-kit/components/Quote'
import { body1, body2, caption, h1, h2, h3, h4, h5 } from '@nxt-insurance/ui-kit/core/typography'

import type { HorizontalAlignment } from '@/cms/helperTypes'
import type { PortableTextComponentProps } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'

export const Block = (props: {
  align: HorizontalAlignment
  node: PortableTextComponentProps<
    PortableTextBlock & {
      align?: HorizontalAlignment
    }
  >
}) => {
  const {
    value: { style = 'normal', align = props.align },
    children,
  } = props.node

  if (!Array.isArray(children)) {
    return null
  }

  if (!children.length) {
    return null
  }
  switch (style) {
    case 'h1': {
      return <p className={h1({ align })}>{children}</p>
    }
    case 'h2': {
      return <p className={h2({ align })}>{children}</p>
    }
    case 'h3': {
      return <p className={h3({ align })}>{children}</p>
    }
    case 'h4': {
      return <p className={h4({ align })}>{children}</p>
    }
    case 'h5': {
      return <p className={h5({ align })}>{children}</p>
    }
    case 'h1Adieu': {
      return <p className={h1({ align, type: 'primary' })}>{children}</p>
    }
    case 'h2Adieu': {
      return <p className={h2({ align, type: 'primary' })}>{children}</p>
    }
    case 'h3Adieu': {
      return <p className={h3({ align, type: 'primary' })}>{children}</p>
    }
    case 'h4Adieu': {
      return <p className={h4({ align, type: 'primary' })}>{children}</p>
    }

    case 'body1': {
      return <p className={body1({ align })}>{children}</p>
    }
    case 'body2': {
      return <p className={body2({ align })}>{children}</p>
    }
    case 'caption': {
      return <p className={caption()}>{children}</p>
    }
    case 'quote': {
      return <Quote>{children}</Quote>
    }
    default:
      return <p className={body1({ align })}>{children}</p>
  }
}
